import { defineMessages } from "react-intl"

export const inventoryAndIntakeFieldMessages = defineMessages({
	arrivalDateLabel: {
		defaultMessage: "Intake date",
		id: "inventoryAndIntakeInformation.intake.intakeDate.label",
	},
	availableForCustomerFromDateLabel: {
		defaultMessage: "Customer Availability Date",
		id: "inventoryAndIntakeInformation.intake.availableForCustomerFromDate.label",
	},
	availableFromDateLabel: {
		defaultMessage: "Available from date",
		id: "inventoryAndIntakeInformation.inventory.availableFromDate.label",
	},
	expectedArrivalDateLabel: {
		defaultMessage: "Expected arrival date",
		id: "inventoryAndIntakeInformation.inventory.expectedArrivalDate.label",
	},
	intakeTitle: {
		defaultMessage: "Intake information",
		id: "inventoryAndIntakeInformation.intake.title",
	},
	inventoryNumberLabel: {
		defaultMessage: "Inventory Number",
		id: "vehicle.inventoryNumber",
	},
	inventoryTitle: {
		defaultMessage: "Inventory",
		id: "inventoryAndIntakeInformation.inventory.title",
	},
	licensePlateLabel: {
		defaultMessage: "Licenseplate",
		id: "inventoryAndIntakeInformation.inventory.licensePlace.label",
	},
	masterNumberChLabel: {
		defaultMessage: "Master Number",
		id: "inventoryAndIntakeInformation.inventory.masterNumberCh.label",
	},
	mileageAccordingToPreviousOwnersLabel: {
		defaultMessage: "Mileage according to previous owner",
		id: "inventoryAndIntakeInformation.intake.mileageAccordingToPreviousOwners.label",
	},
	stockStatusLabel: {
		defaultMessage: "Stock status",
		id: "inventoryAndIntakeInformation.inventory.stockStatus.label",
	},
	typeKeyNumberLabel: {
		defaultMessage: "Type Key Number",
		id: "inventoryAndIntakeInformation.inventory.typeKeyNumber.label",
	},
	vehicleConditionLabel: {
		defaultMessage: "Vehicle condition",
		id: "inventoryAndIntakeInformation.inventory.vehicleCondition.label",
	},
	vehicleOriginLabel: {
		defaultMessage: "Vehicle origin",
		id: "vehicle.vehicleOrigin",
	},
	vehicleTypeLabel: {
		defaultMessage: "Vehicle type",
		id: "inventoryAndIntakeInformation.inventory.vehicleType.label",
	},
})
